import { Button, Col, Form, Input, InputNumber, Row, Select } from "antd"
import patterns from "config/patterns";
import useApi from "hooks/useApi";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LinkForShare from "./LinkForShare";
import addreses from "config/api/addresses";
import util from "config/utils";
import { WageSide } from "models/paymentLink";

const Simple = () => {
    const [link, setLink] = useState<string>("")
    const [name, setName] = useState<string>("")
    const [frm] = Form.useForm();
    const { t } = useTranslation();
    const [pay, creating] = useApi({
        onSuccess: (l) => {
            setLink(l as string);
            frm.resetFields();
        }
    })
    const onConfirm = (data: any) => {
        setName(data.payerName)
        pay.post(addreses.createSimplePaymentLink, {
            ...data
        })
    }
    return <div id='simple-payment-link'
        className="center"
        style={{
            width: "100%",
            borderRight: "solid 1px #eee",
            borderBottom: "solid 1px #eee",
            borderLeft: "solid 1px #eee",
            padding: "1rem"
        }}>
        {!link ?
            <Form
                name="simple-frm"
                form={frm}
                onFinish={onConfirm}
                autoComplete="off"
                layout="vertical"
                style={{ maxWidth: 500 }}
                initialValues={{wageSide:WageSide.merchant}}
            >
                <Row gutter={[20, 20]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="amount"
                            label={t("amount")}
                            rules={[{ required: true, message: t("required") ?? "" }]}>
                            <InputNumber
                                stringMode={true}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                                placeholder={t("amount") ?? ""}
                                className="ltr-elm placeholder-r w-100"
                                controls={false}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="payerName"
                            label={`${t("name")} ${t("payer")}`}
                            rules={[{ required: true, message: t("required") ?? "" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="payerMobileNumber"
                            label={`${t("mobileNumber")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.mobile,
                                    message: t("wrongFormat") ?? ""
                                }
                            ]}
                        >
                            <Input placeholder={t("mobileNumber") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="payerNationalCode"
                            label={`${t("nationalCode")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.nationalCode,
                                    message: t("wrongFormat") ?? ""
                                }
                            ]}>
                            <Input placeholder={t("nationalCode") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="payerEmail"
                            label={`${t("email")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.email,
                                    message: t("wrongFormat") ?? ""
                                }
                            ]}>
                            <Input placeholder={t("email") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item name="wageSide" label={t("wageSide")} rules={[
                            {
                                required: true,
                                message: t("required") ?? "",
                            }
                        ]}>
                            <Select
                                showSearch
                                placeholder={t("wageSide")}
                                options={util.convrtEnumToOptions(WageSide)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24}>
                        <Form.Item
                            name="description"
                            label={t("description")}
                            rules={[
                                {
                                    required: true,
                                    message: t("required") ?? "",
                                }
                            ]}>
                            <Input.TextArea placeholder={t("description") ?? ""} className="" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24}>
                        <Form.Item className="flex-row-end btns" >
                            <Button type="primary" htmlType="submit" loading={creating}>
                                {t("createLink")}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            : <LinkForShare
                link={link}
                name={name}
                onBack={() => {
                    setName("");
                    setLink("");
                }}
            />
        }
    </div>;
}
export default Simple;